import { makeServerRequest } from './util';
import {setLanguage} from './i18n';

const apiPrefix = "/api/v1/userinfo";

export const getUserSuccess = (data) => {

    return (dispatch) => {
        dispatch({type: "FETCH_USER_SUCCESS", payload: data});
        dispatch(setLanguage(data.language));
    };

};

export const getUserFailure = (error) => {
    return {
        type: "FETCH_USER_FAILURE",
        payload: {}//error
    };
};

export const getUser = () => {

    return (dispatch) => {
        dispatch({type: "FETCH_USER"});

        return makeServerRequest(apiPrefix).then(
            response => dispatch(getUserSuccess(response.data))
        ).catch(
            error => dispatch(getUserFailure(error))
        );
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/user.js